module.exports = __webpack_public_path__ + "56518ea207162a90ed315882569e2c41.svg";